import * as Address from './address.js';
import * as AgentConversation from './agentConversation.js';
import * as AgentConversationResponseTemplate from './agentConversationResponseTemplate.js';
import * as AgentConversationTags from './agentConversationTags.js';
import * as AgenticPlatformSession from './agenticPlatformSession.js';
import * as AllowedDomains from './allowedDomains.js';
import * as Analyst from './analyst.js';
import * as AssignmentGroup from './assignmentGroup.js';
import * as AssignmentGroupUser from './assignmentGroupUser.js';
import * as VoiceAssistant from './assistant/assistant.js';
import * as AssistantDefinition from './assistant/assistantDefinition.js';
import * as AssistantToolsTypes from './assistant/assistantToolType.js';
import * as AssistantChatSession from './assistant/chatSession.js';
import * as AssistantLlmModel from './assistant/llmModel.js';
import * as AssistantToolDefinition from './assistant/toolDefinition.js';
import * as AssistantVoiceCall from './assistant/voiceCall.js';
import * as AssistantVoicePersona from './assistant/voicePersona.js';
import * as Assistant from './assistant.js';
import * as PortalAuthentication from './authentication/portal.js';
import * as Authorization from './authorization/submission.js';
import * as Availabilities from './availabilities.js';
import * as Balance from './balance.js';
import * as Broadcast from './broadcast.js';
import * as BusinessIntelligenceEmbed from './businessIntelligenceEmbed.js';
import * as Captcha from './captcha.js';
import * as CareGapFindings from './careGapFindings.js';
import * as CareProvider from './careProvider.js';
import * as common from './common.js';
import * as CommunicationVendorAccount from './communicationVendorAccount.js';
import * as Connection from './connection.js';
import * as CopilotJob from './copilot/job.js';
import * as CopilotSession from './copilot/session.js';
import * as CrawlerApiConfig from './crawlerApi/config.js';
import * as DashboardEmbed from './dashboardEmbed.js';
import * as DecisionTree from './decisionTree.js';
import * as Diagnostics from './diagnostics.js';
import * as Document from './document/index.js';
import * as DocumentTemplate from './document/template.js';
import * as EhrInformation from './ehrInformation.js';
import * as EhrProviderInformation from './ehrProviderInformation.js';
import * as EhrSystem from './ehrSystem.js';
import * as EhrTimeSlot from './ehrTimeSlot.js';
import * as EhrTimeSlotBooking from './ehrTimeSlotBooking.js';
import * as EhrTwoFactor from './ehrTwoFactor.js';
import * as Encounter from './encounter.js';
import * as ExternalDocumentPacket from './externalDocumentPacket.js';
import * as ExternalOrder from './externalOrder.js';
import * as FeatureFlag from './featureFlag.js';
import * as Feed from './feed.js';
import * as FeedItem from './feedItems.js';
import * as FeedMessage from './feedMessages.js';
import * as PatientFeedback from './feedback.js';
import * as Fingerprint from './fingerprint.js';
import * as FivetranConnector from './fivetranConnector.js';
import * as FlowAdmin from './flow/admin.js';
import * as FlowAssistant from './flow/assistant.js';
import * as FlowBatchTest from './flow/batchTest.js';
import * as FlowBlock from './flow/block.js';
import * as FlowBlockLog from './flow/blockLog.js';
import * as FlowBlockTypeMetadata from './flow/blockTypeMetadata.js';
import * as File from './flow/file.js';
import * as Flow from './flow/flow.js';
import * as FlowAgent from './flow/flowAgent.js';
import * as FlowAlertRule from './flow/flowAlertRule.js';
import * as FlowBlockTemplate from './flow/flowBlockTemplate.js';
import * as FlowDefinition from './flow/flowDefinition.js';
import * as FlowDefinitionTemplate from './flow/flowDefinitionTemplate.js';
import * as FlowExecution from './flow/flowExecution.js';
import * as FlowRun from './flow/flowRun.js';
import * as FlowRunAnalyticEvent from './flow/flowRunAnalyticEvent.js';
import * as FlowRunBlockMetric from './flow/flowRunBlockMetric.js';
import * as FlowRunExplore from './flow/flowRunExplore.js';
import * as FlowRunFleet from './flow/flowRunFleet.js';
import * as FlowRunSignal from './flow/flowRunSignal.js';
import * as HumanTask from './flow/humanTask.js';
import * as Metric from './flow/metric.js';
import * as FlowModelLifecycle from './flow/modelLifecycle.js';
import * as FlowPermissions from './flow/permissions.js';
import * as FlowReferenceTable from './flow/referenceTable.js';
import * as SecureHeaders from './flow/secureHeaders.js';
import * as StandardAnalyticEvent from './flow/standardAnalyticEvent.js';
import * as StandardAnalyticEventCategory from './flow/standardAnalyticEventCategory.js';
import * as Tag from './flow/tag.js';
import * as FlowTestCases from './flow/testCaseGeneration.js';
import * as FlowTestPatient from './flow/testPatient.js';
import * as FlowTriggerSchedules from './flow/triggerSchedules.js';
import * as Triggers from './flow/triggers.js';
import * as FlowRunTaskEvent from './flowRunTaskEvent.js';
import * as FrontDeskDevice from './frontDeskDevice.js';
import * as Group from './group.js';
import * as HccFindings from './hccFindings.js';
import * as InsuranceCardOcrResult from './insuranceOcrResult.js';
import * as InsuranceProvider from './insuranceProvider.js';
import * as InsuranceRteRequest from './insuranceRteRequest.js';
import * as IpLocation from './iplocation.js';
import * as KnowledgeBaseFile from './knowledgeBaseFile.js';
import * as Log from './log.js';
import * as Maps from './maps.js';
import * as Mindtickle from './mindtickle.js';
import * as Models from './models/index.js';
import * as Note from './note.js';
import * as NoteTemplate from './noteTemplate.js';
import * as NoticeOfAdmission from './noticeOfAdmission.js';
import * as NotificationContent from './notification/content.js';
import * as NotificationIntent from './notification/intent.js';
import * as NotificationRequest from './notification/request.js';
import * as NotificationSchedule from './notification/schedule.js';
import * as NotificationScheme from './notification/scheme.js';
import * as Notifications from './notifications.js';
import * as Orchestrator from './orchestrator/index.js';
import * as OrganizationAssistantConfiguration from './organization/assistant/configuration.js';
import * as Organization from './organization/index.js';
import * as OutreachPatients from './outreachPatients.js';
import * as ClinicalAlgorithmsData from './patient/clinicalAlgorithmsData.js';
import * as PatientDocument from './patient/document.js';
import * as PatientFinding from './patient/finding.js';
import * as ClinicalPacket from './patient/order/clinicalPacket.js';
import * as ClinicalQuestion from './patient/order/clinicalQuestion.js';
import * as PatientOrder from './patient/order/index.js';
import * as Patient from './patient.js';
import * as PatientAdvisory from './patientAdvisory.js';
import * as PatientAdvisoryDocument from './patientAdvisoryDocument.js';
import * as PatientCareTeam from './patientCareTeam.js';
import * as PatientInformation from './patientInformation.js';
import * as PatientInsuranceInformation from './patientInsuranceInformation.js';
import * as PatientSsn from './patientSsn.js';
import * as PatientUpload from './patientUpload.js';
import * as Payment from './payment.js';
import * as PayorClearinghouse from './payor/clearinghouse.js';
import * as Payor from './payor.js';
import * as PayoutAdjustment from './payoutAdjustment.js';
import * as Payouts from './payouts.js';
import * as Pharmacy from './pharmacy.js';
import * as PhoneNumberCapability from './phoneNumber/phoneNumberCapability.js';
import * as AssistantPhoneNumberConfiguration from './phoneNumber/phoneNumberConfiguration.js';
import * as PhoneNumberPracticeMapping from './phoneNumber/phoneNumberPracticeMapping.js';
import * as VendorPhoneNumber from './phoneNumber/vendorPhoneNumber.js';
import * as Places from './places.js';
import * as Population from './population.js';
import * as PracticePreference from './practice/preference.js';
import * as PracticeTheme from './practice/theme.js';
import * as Practice from './practice.js';
import * as PracticeGroup from './practiceGroup.js';
import * as PredictDocument from './predict/document.js';
import * as PredictVision from './predict/vision.js';
import * as Preferences from './preferences.js';
import * as Appointment from './previsit/appointment.js';
import * as PrevisitDirectory from './previsit/directory.js';
import * as PrevisitDocumentTemplate from './previsit/documentTemplate.js';
import * as PrevisitLink from './previsit/link.js';
import * as PrevisitMessageRequest from './previsit/messageRequest.js';
import * as PrevisitMessageRequestLink from './previsit/messageRequestLink.js';
import * as PrevisitOrganization from './previsit/organization.js';
import * as PrevisitPatientInsuranceInformation from './previsit/patientInsuranceInformation.js';
import * as PrevisitPatientOrder from './previsit/patientOrder.js';
import * as PrevisitPayor from './previsit/payor.js';
import * as PrevisitProvider from './previsit/provider.js';
import * as Previsit from './previsit.js';
import * as PrevisitFormTemplate from './previsitFormTemplate.js';
import * as ProblemGroup from './problemGroup.js';
import * as Procedure from './procedure.js';
import * as Provider from './provider.js';
import * as ProviderNoteField from './providerNoteField.js';
import * as ProviderNoteSection from './providerNoteSection.js';
import * as ProviderOrganizationPreference from './providerOrganizationPreference.js';
import * as ProviderProfile from './providerProfile.js';
import * as ProviderTeam from './providerTeam.js';
import * as ProvisionalPatient from './provisionalPatient.js';
import * as RealTimeEligibility from './realTimeEligibility.js';
import * as RecommendationTemplate from './recommendationTemplate.js';
import * as ReportFeedback from './report/feedback.js';
import * as RescheduleEhrTimeSlot from './rescheduleEhrTimeSlot.js';
import * as ResourceGatewayIngestionJob from './resourceGateway/ingestionJob.js';
import * as FhirPathCompletion from './resourceGateway/pathCompletion.js';
import * as ResourceDefinition from './resourceGateway/resourceDefinition.js';
/** Only used when resourceFirstArchitectureDemo flag is on */
import * as ResourceFlowTrigger from './resourceGateway/resourceFlowTrigger.js';
import * as Transformation from './resourceGateway/transformation.js';
import * as RpaJob from './rpaJob.js';
import * as Saml from './saml.js';
import * as Scenario from './scenario.js';
import * as Search from './search.js';
import * as ServiceAccount from './serviceAccount.js';
import * as Sftp from './sftp.js';
import * as StandardNoteField from './standardNoteField.js';
import * as StandardNoteSection from './standardNoteSection.js';
import * as StripeAccount from './stripeAccount.js';
import * as Timeline from './timeline.js';
import * as UserGroup from './user/group.js';
import * as UserLinkedUser from './user/linkedUser.js';
import * as UserPreferences from './user/preferences.js';
import * as User from './user.js';
import * as UtilizationDashboardEmbed from './utilizationDashboardEmbed.js';
import * as Vidyard from './vidyard.js';
import * as Visit from './visit.js';
import * as VisitReason from './visitReason.js';
import * as VpnConnection from './vpnConnection.js';
import * as Workflow from './workflow.js';
import * as WorkflowTest from './workflowTest/index.js';

export { type AxiosProgressEvent } from 'axios';
export { APIError } from './models/common.js';
export * from './models/index.js';

type Environment = Models.Common.Environment;
const Environment = Models.Common.Environment;
export { Environment };

// and make a Client class available, such that can easily configure which backend to call
export class Client {
  common: common.Common;
  StripeAccount: StripeAccount.API;
  Address: Address.API;
  AgentConversation: AgentConversation.API;
  AgentConversationResponseTemplate: AgentConversationResponseTemplate.API;
  AgentConversationTags: AgentConversationTags.API;
  AgenticPlatformSession: AgenticPlatformSession.API;
  AllowedDomains: AllowedDomains.API;
  Analyst: Analyst.API;
  Appointment: Appointment.API;
  Assistant: Assistant.API;
  AssistantChatSession: AssistantChatSession.API;
  AssistantPhoneNumberConfiguration: AssistantPhoneNumberConfiguration.API;
  AssistantVoiceCall: AssistantVoiceCall.API;
  AssistantVoicePersona: AssistantVoicePersona.API;
  AssistantLlmModel: AssistantLlmModel.API;
  AssistantDefinition: AssistantDefinition.API;
  AssignmentGroup: AssignmentGroup.API;
  AssignmentGroupUser: AssignmentGroupUser.API;
  AssistantToolDefinition: AssistantToolDefinition.API;
  AssistantToolsTypes: AssistantToolsTypes.API;
  VoiceAssistant: VoiceAssistant.API;
  Authorization: Authorization.API;
  Availabilities: Availabilities.API;
  Balance: Balance.API;
  Broadcast: Broadcast.API;
  BusinessIntelligenceEmbed: BusinessIntelligenceEmbed.API;
  Captcha: Captcha.API;
  CareGapFindings: CareGapFindings.API;
  CareProvider: CareProvider.API;
  ClinicalAlgorithmsData: ClinicalAlgorithmsData.API;
  ClinicalPacket: ClinicalPacket.API;
  ClinicalQuestion: ClinicalQuestion.API;
  CommunicationVendorAccount: CommunicationVendorAccount.API;
  CopilotJob: CopilotJob.API;
  Connection: Connection.API;
  CopilotSession: CopilotSession.API;
  CrawlerApiConfig: CrawlerApiConfig.API;
  DashboardEmbed: DashboardEmbed.API;
  DecisionTree: DecisionTree.API;
  Diagnostics: Diagnostics.API;
  Document: Document.API;
  DocumentTemplate: DocumentTemplate.API;
  EhrInformation: EhrInformation.API;
  EhrProviderInformation: EhrProviderInformation.API;
  EhrSystem: EhrSystem.API;
  EhrTimeSlot: EhrTimeSlot.API;
  EhrTimeSlotBooking: EhrTimeSlotBooking.API;
  EhrTwoFactor: EhrTwoFactor.API;
  Encounter: Encounter.API;
  ExternalDocumentPacket: ExternalDocumentPacket.API;
  ExternalOrder: ExternalOrder.API;
  FeatureFlag: FeatureFlag.API;
  Feed: Feed.API;
  FeedItem: FeedItem.API;
  FeedMessage: FeedMessage.API;
  Fingerprint: Fingerprint.API;
  FivetranConnector: FivetranConnector.API;
  File: File.API;
  Flow: Flow.API;
  FlowAdmin: FlowAdmin.API;
  FlowBlock: FlowBlock.API;
  FlowAlertRule: FlowAlertRule.API;
  FlowAgent: FlowAgent.API;
  FlowAssistant: FlowAssistant.API;
  FlowBatchTest: FlowBatchTest.API;
  FlowTestCases: FlowTestCases.API;
  FlowBlockLog: FlowBlockLog.API;
  FlowBlockTypeMetadata: FlowBlockTypeMetadata.API;
  FlowDefinition: FlowDefinition.API;
  FlowDefinitionTemplate: FlowDefinitionTemplate.API;
  FlowModelLifecycle: FlowModelLifecycle.API;
  FlowExecution: FlowExecution.API;
  FlowReferenceTable: FlowReferenceTable.API;
  FlowRun: FlowRun.API;
  FlowRunAnalyticEvent: FlowRunAnalyticEvent.API;
  FlowRunFleet: FlowRunFleet.API;
  FlowRunBlockMetric: FlowRunBlockMetric.API;
  FlowRunSignal: FlowRunSignal.API;
  FlowPermissions: FlowPermissions.API;
  FlowBlockTemplate: FlowBlockTemplate.API;
  FlowTriggerSchedules: FlowTriggerSchedules.API;
  FlowTestPatient: FlowTestPatient.API;
  FlowRunTaskEvent: FlowRunTaskEvent.API;
  FrontDeskDevice: FrontDeskDevice.API;
  Group: Group.API;
  HccFindings: HccFindings.API;
  HumanTask: HumanTask.API;
  InsuranceCardOcrResult: InsuranceCardOcrResult.API;
  InsuranceProvider: InsuranceProvider.API;
  InsuranceRteRequest: InsuranceRteRequest.API;
  IpLocation: IpLocation.API;
  KnowledgeBaseFile: KnowledgeBaseFile.API;
  Log: Log.API;
  Maps: Maps.API;
  Mindtickle: Mindtickle.API;
  Note: Note.API;
  NoteTemplate: NoteTemplate.API;
  NoticeOfAdmission: NoticeOfAdmission.API;
  NotificationContent: NotificationContent.API;
  NotificationIntent: NotificationIntent.API;
  NotificationRequest: NotificationRequest.API;
  Notifications: Notifications.API;
  NotificationSchedule: NotificationSchedule.API;
  NotificationScheme: NotificationScheme.API;
  Orchestrator: Orchestrator.API;
  Organization: Organization.API;
  OrganizationAssistantConfiguration: OrganizationAssistantConfiguration.API;
  OutreachPatients: OutreachPatients.API;
  Patient: Patient.API;
  PatientAdvisory: PatientAdvisory.API;
  PatientAdvisoryDocument: PatientAdvisoryDocument.API;
  PatientCareTeam: PatientCareTeam.API;
  PatientDocument: PatientDocument.API;
  PatientFeedback: PatientFeedback.API;
  PatientFinding: PatientFinding.API;
  PatientInformation: PatientInformation.API;
  PatientInsuranceInformation: PatientInsuranceInformation.API;
  PatientOrder: PatientOrder.API;
  PatientSsn: PatientSsn.API;
  PatientUpload: PatientUpload.API;
  Payment: Payment.API;
  Payor: Payor.API;
  PayorClearinghouse: PayorClearinghouse.API;
  Payouts: Payouts.API;
  PayoutAdjustment: PayoutAdjustment.API;
  PhoneNumberCapability: PhoneNumberCapability.API;
  PhoneNumberPracticeMapping: PhoneNumberPracticeMapping.API;
  Pharmacy: Pharmacy.API;
  Places: Places.API;
  Population: Population.API;
  PortalAuthentication: PortalAuthentication.API;
  Practice: Practice.API;
  PracticeGroup: PracticeGroup.API;
  PracticePreference: PracticePreference.API;
  PracticeTheme: PracticeTheme.API;
  PrevisitDirectory: PrevisitDirectory.API;
  PredictDocument: PredictDocument.API;
  PredictVision: PredictVision.API;
  Previsit: Previsit.API;
  PrevisitDocumentTemplate: PrevisitDocumentTemplate.API;
  PrevisitFormTemplate: PrevisitFormTemplate.API;
  PrevisitLink: PrevisitLink.API;
  PrevisitMessageRequest: PrevisitMessageRequest.API;
  PrevisitMessageRequestLink: PrevisitMessageRequestLink.API;
  PrevisitOrganization: PrevisitOrganization.API;
  PrevisitPatientInsuranceInformation: PrevisitPatientInsuranceInformation.API;
  PrevisitPatientOrder: PrevisitPatientOrder.API;
  PrevisitPayor: PrevisitPayor.API;
  PrevisitProvider: PrevisitProvider.API;
  ProblemGroup: ProblemGroup.API;
  Procedure: Procedure.API;
  Provider: Provider.API;
  ProviderNoteField: ProviderNoteField.API;
  ProviderNoteSection: ProviderNoteSection.API;
  ProviderOrganizationPreference: ProviderOrganizationPreference.API;
  ProviderProfile: ProviderProfile.API;
  ProviderTeam: ProviderTeam.API;
  ProvisionalPatient: ProvisionalPatient.API;
  RealTimeEligibility: RealTimeEligibility.API;
  RecommendationTemplate: RecommendationTemplate.API;
  ResourceGatewayIngestionJob: ResourceGatewayIngestionJob.API;
  FhirPathCompletion: FhirPathCompletion.API;
  ResourceDefinition: ResourceDefinition.API;
  /** Only used when resourceFirstArchitectureDemo flag is on */
  ResourceFlowTrigger: ResourceFlowTrigger.API;
  Transformation: Transformation.API;
  ReportFeedback: ReportFeedback.API;
  RescheduleEhrTimeSlot: RescheduleEhrTimeSlot.API;
  RpaJob: RpaJob.API;
  Saml: Saml.API;
  Scenario: Scenario.API;
  Search: Search.API;
  SecureHeaders: SecureHeaders.API;
  StandardAnalyticEvent: StandardAnalyticEvent.API;
  StandardAnalyticEventCategory: StandardAnalyticEventCategory.API;
  ServiceAccount: ServiceAccount.API;
  Sftp: Sftp.API;
  StandardNoteField: StandardNoteField.API;
  StandardNoteSection: StandardNoteSection.API;
  Tag: Tag.API;
  Timeline: Timeline.API;
  Triggers: Triggers.API;
  User: User.API;
  UserGroup: UserGroup.API;
  UserLinkedUser: UserLinkedUser.API;
  UserPreferences: UserPreferences.API;
  UtilizationDashboardEmbed: UtilizationDashboardEmbed.API;
  Preferences: Preferences.API;
  VendorPhoneNumber: VendorPhoneNumber.API;
  Vidyard: Vidyard.API;
  Visit: Visit.API;
  VisitReason: VisitReason.API;
  VpnConnection: VpnConnection.API;
  Workflow: Workflow.API;
  WorkflowTest: WorkflowTest.API;
  FlowRunExplore: FlowRunExplore.API;
  Metric: Metric.API;

  constructor(env: Models.Common.Environment = Models.Common.Environment.Webprod) {
    this.common = new common.Common(env);
    this.StripeAccount = new StripeAccount.API(this.common);
    this.Address = new Address.API(this.common);
    this.AgentConversation = new AgentConversation.API(this.common);
    this.AgentConversationResponseTemplate = new AgentConversationResponseTemplate.API(this.common);
    this.AgentConversationTags = new AgentConversationTags.API(this.common);
    this.AgenticPlatformSession = new AgenticPlatformSession.API(this.common);
    this.AllowedDomains = new AllowedDomains.API(this.common);
    this.Analyst = new Analyst.API(this.common);
    this.Appointment = new Appointment.API(this.common);
    this.Assistant = new Assistant.API(this.common);
    this.AssistantChatSession = new AssistantChatSession.API(this.common);
    this.AssistantPhoneNumberConfiguration = new AssistantPhoneNumberConfiguration.API(this.common);
    this.AssistantVoiceCall = new AssistantVoiceCall.API(this.common);
    this.AssistantVoicePersona = new AssistantVoicePersona.API(this.common);
    this.AssistantLlmModel = new AssistantLlmModel.API(this.common);
    this.AssistantDefinition = new AssistantDefinition.API(this.common);
    this.AssignmentGroup = new AssignmentGroup.API(this.common);
    this.AssignmentGroupUser = new AssignmentGroupUser.API(this.common);
    this.AssistantToolDefinition = new AssistantToolDefinition.API(this.common);
    this.AssistantToolsTypes = new AssistantToolsTypes.API(this.common);
    this.VoiceAssistant = new VoiceAssistant.API(this.common);
    this.Authorization = new Authorization.API(this.common);
    this.Availabilities = new Availabilities.API(this.common);
    this.Balance = new Balance.API(this.common);
    this.Broadcast = new Broadcast.API(this.common);
    this.BusinessIntelligenceEmbed = new BusinessIntelligenceEmbed.API(this.common);
    this.Captcha = new Captcha.API(this.common);
    this.CareGapFindings = new CareGapFindings.API(this.common);
    this.CareProvider = new CareProvider.API(this.common);
    this.ClinicalAlgorithmsData = new ClinicalAlgorithmsData.API(this.common);
    this.ClinicalPacket = new ClinicalPacket.API(this.common);
    this.ClinicalQuestion = new ClinicalQuestion.API(this.common);
    this.CommunicationVendorAccount = new CommunicationVendorAccount.API(this.common);
    this.CopilotJob = new CopilotJob.API(this.common);
    this.Connection = new Connection.API(this.common);
    this.CopilotSession = new CopilotSession.API(this.common);
    this.CrawlerApiConfig = new CrawlerApiConfig.API(this.common);
    this.DashboardEmbed = new DashboardEmbed.API(this.common);
    this.DecisionTree = new DecisionTree.API(this.common);
    this.Diagnostics = new Diagnostics.API(this.common);
    this.Document = new Document.API(this.common);
    this.DocumentTemplate = new DocumentTemplate.API(this.common);
    this.EhrInformation = new EhrInformation.API(this.common);
    this.EhrProviderInformation = new EhrProviderInformation.API(this.common);
    this.EhrSystem = new EhrSystem.API(this.common);
    this.EhrTimeSlot = new EhrTimeSlot.API(this.common);
    this.EhrTimeSlotBooking = new EhrTimeSlotBooking.API(this.common);
    this.EhrTwoFactor = new EhrTwoFactor.API(this.common);
    this.Encounter = new Encounter.API(this.common);
    this.ExternalDocumentPacket = new ExternalDocumentPacket.API(this.common);
    this.ExternalOrder = new ExternalOrder.API(this.common);
    this.FeatureFlag = new FeatureFlag.API(this.common);
    this.Feed = new Feed.API(this.common);
    this.FeedItem = new FeedItem.API(this.common);
    this.FeedMessage = new FeedMessage.API(this.common);
    this.File = new File.API(this.common);
    this.Fingerprint = new Fingerprint.API(this.common);
    this.FivetranConnector = new FivetranConnector.API(this.common);
    this.Flow = new Flow.API(this.common);
    this.FlowAdmin = new FlowAdmin.API(this.common);
    this.FlowBlock = new FlowBlock.API(this.common);
    this.FlowAlertRule = new FlowAlertRule.API(this.common);
    this.FlowAgent = new FlowAgent.API(this.common);
    this.FlowAssistant = new FlowAssistant.API(this.common);
    this.FlowBatchTest = new FlowBatchTest.API(this.common);
    this.FlowTestCases = new FlowTestCases.API(this.common);
    this.FlowBlockTypeMetadata = new FlowBlockTypeMetadata.API(this.common);
    this.FlowBlockLog = new FlowBlockLog.API(this.common);
    this.FlowDefinition = new FlowDefinition.API(this.common);
    this.FlowDefinitionTemplate = new FlowDefinitionTemplate.API(this.common);
    this.FlowModelLifecycle = new FlowModelLifecycle.API(this.common);
    this.FlowExecution = new FlowExecution.API(this.common);
    this.FlowReferenceTable = new FlowReferenceTable.API(this.common);
    this.FlowRun = new FlowRun.API(this.common);
    this.FlowRunAnalyticEvent = new FlowRunAnalyticEvent.API(this.common);
    this.FlowRunBlockMetric = new FlowRunBlockMetric.API(this.common);
    this.FlowRunExplore = new FlowRunExplore.API(this.common);
    this.Metric = new Metric.API(this.common);
    this.FlowRunFleet = new FlowRunFleet.API(this.common);
    this.FlowRunSignal = new FlowRunSignal.API(this.common);
    this.FlowPermissions = new FlowPermissions.API(this.common);
    this.FlowBlockTemplate = new FlowBlockTemplate.API(this.common);
    this.FlowTriggerSchedules = new FlowTriggerSchedules.API(this.common);
    this.FlowTestPatient = new FlowTestPatient.API(this.common);
    this.FlowRunTaskEvent = new FlowRunTaskEvent.API(this.common);
    this.FrontDeskDevice = new FrontDeskDevice.API(this.common);
    this.Group = new Group.API(this.common);
    this.HccFindings = new HccFindings.API(this.common);
    this.HumanTask = new HumanTask.API(this.common);
    this.InsuranceCardOcrResult = new InsuranceCardOcrResult.API(this.common);
    this.InsuranceProvider = new InsuranceProvider.API(this.common);
    this.InsuranceRteRequest = new InsuranceRteRequest.API(this.common);
    this.IpLocation = new IpLocation.API(this.common);
    this.KnowledgeBaseFile = new KnowledgeBaseFile.API(this.common);
    this.Log = new Log.API(this.common);
    this.Maps = new Maps.API(this.common);
    this.Mindtickle = new Mindtickle.API(this.common);
    this.Note = new Note.API(this.common);
    this.NoteTemplate = new NoteTemplate.API(this.common);
    this.NoticeOfAdmission = new NoticeOfAdmission.API(this.common);
    this.NotificationContent = new NotificationContent.API(this.common);
    this.NotificationIntent = new NotificationIntent.API(this.common);
    this.NotificationRequest = new NotificationRequest.API(this.common);
    this.Notifications = new Notifications.API(this.common);
    this.NotificationSchedule = new NotificationSchedule.API(this.common);
    this.NotificationScheme = new NotificationScheme.API(this.common);
    this.Orchestrator = new Orchestrator.API(this.common);
    this.Organization = new Organization.API(this.common);
    this.OrganizationAssistantConfiguration = new OrganizationAssistantConfiguration.API(
      this.common
    );
    this.OutreachPatients = new OutreachPatients.API(this.common);
    this.Patient = new Patient.API(this.common);
    this.PatientAdvisory = new PatientAdvisory.API(this.common);
    this.PatientAdvisoryDocument = new PatientAdvisoryDocument.API(this.common);
    this.PatientCareTeam = new PatientCareTeam.API(this.common);
    this.PatientDocument = new PatientDocument.API(this.common);
    this.PatientFeedback = new PatientFeedback.API(this.common);
    this.PatientFinding = new PatientFinding.API(this.common);
    this.PatientInformation = new PatientInformation.API(this.common);
    this.PatientInsuranceInformation = new PatientInsuranceInformation.API(this.common);
    this.PatientOrder = new PatientOrder.API(this.common);
    this.PatientSsn = new PatientSsn.API(this.common);
    this.PatientUpload = new PatientUpload.API(this.common);
    this.Payment = new Payment.API(this.common);
    this.Payor = new Payor.API(this.common);
    this.PayorClearinghouse = new PayorClearinghouse.API(this.common);
    this.Payouts = new Payouts.API(this.common);
    this.PayoutAdjustment = new PayoutAdjustment.API(this.common);
    this.PhoneNumberCapability = new PhoneNumberCapability.API(this.common);
    this.PhoneNumberPracticeMapping = new PhoneNumberPracticeMapping.API(this.common);
    this.Pharmacy = new Pharmacy.API(this.common);
    this.Places = new Places.API(this.common);
    this.Population = new Population.API(this.common);
    this.PortalAuthentication = new PortalAuthentication.API(this.common);
    this.Practice = new Practice.API(this.common);
    this.PracticeGroup = new PracticeGroup.API(this.common);
    this.PracticePreference = new PracticePreference.API(this.common);
    this.PracticeTheme = new PracticeTheme.API(this.common);
    this.PredictDocument = new PredictDocument.API(this.common);
    this.PredictVision = new PredictVision.API(this.common);
    this.Previsit = new Previsit.API(this.common);
    this.PrevisitDirectory = new PrevisitDirectory.API(this.common);
    this.PrevisitDocumentTemplate = new PrevisitDocumentTemplate.API(this.common);
    this.PrevisitFormTemplate = new PrevisitFormTemplate.API(this.common);
    this.PrevisitLink = new PrevisitLink.API(this.common);
    this.PrevisitMessageRequest = new PrevisitMessageRequest.API(this.common);
    this.PrevisitMessageRequestLink = new PrevisitMessageRequestLink.API(this.common);
    this.PrevisitOrganization = new PrevisitOrganization.API(this.common);
    this.PrevisitPatientInsuranceInformation = new PrevisitPatientInsuranceInformation.API(
      this.common
    );
    this.PrevisitPatientOrder = new PrevisitPatientOrder.API(this.common);
    this.PrevisitPayor = new PrevisitPayor.API(this.common);
    this.PrevisitProvider = new PrevisitProvider.API(this.common);
    this.ProblemGroup = new ProblemGroup.API(this.common);
    this.Procedure = new Procedure.API(this.common);
    this.Provider = new Provider.API(this.common);
    this.ProviderNoteField = new ProviderNoteField.API(this.common);
    this.ProviderNoteSection = new ProviderNoteSection.API(this.common);
    this.ProviderOrganizationPreference = new ProviderOrganizationPreference.API(this.common);
    this.ProviderProfile = new ProviderProfile.API(this.common);
    this.ProviderTeam = new ProviderTeam.API(this.common);
    this.ProvisionalPatient = new ProvisionalPatient.API(this.common);
    this.RealTimeEligibility = new RealTimeEligibility.API(this.common);
    this.RecommendationTemplate = new RecommendationTemplate.API(this.common);
    this.ResourceGatewayIngestionJob = new ResourceGatewayIngestionJob.API(this.common);
    this.FhirPathCompletion = new FhirPathCompletion.API(this.common);
    this.ResourceDefinition = new ResourceDefinition.API(this.common);
    /** Only used when resourceFirstArchitectureDemo flag is on */
    this.ResourceFlowTrigger = new ResourceFlowTrigger.API(this.common);
    this.Transformation = new Transformation.API(this.common);
    this.ReportFeedback = new ReportFeedback.API(this.common);
    this.RescheduleEhrTimeSlot = new RescheduleEhrTimeSlot.API(this.common);
    this.RpaJob = new RpaJob.API(this.common);
    this.Saml = new Saml.API(this.common);
    this.Scenario = new Scenario.API(this.common);
    this.Search = new Search.API(this.common);
    this.SecureHeaders = new SecureHeaders.API(this.common);
    this.StandardAnalyticEvent = new StandardAnalyticEvent.API(this.common);
    this.StandardAnalyticEventCategory = new StandardAnalyticEventCategory.API(this.common);
    this.ServiceAccount = new ServiceAccount.API(this.common);
    this.Sftp = new Sftp.API(this.common);
    this.StandardNoteField = new StandardNoteField.API(this.common);
    this.StandardNoteSection = new StandardNoteSection.API(this.common);
    this.Tag = new Tag.API(this.common);
    this.Timeline = new Timeline.API(this.common);
    this.Triggers = new Triggers.API(this.common);
    this.User = new User.API(this.common);
    this.UserGroup = new UserGroup.API(this.common);
    this.UserLinkedUser = new UserLinkedUser.API(this.common);
    this.UserPreferences = new UserPreferences.API(this.common);
    this.UtilizationDashboardEmbed = new UtilizationDashboardEmbed.API(this.common);
    this.Preferences = new Preferences.API(this.common);
    this.VendorPhoneNumber = new VendorPhoneNumber.API(this.common);
    this.Vidyard = new Vidyard.API(this.common);
    this.Visit = new Visit.API(this.common);
    this.VisitReason = new VisitReason.API(this.common);
    this.VpnConnection = new VpnConnection.API(this.common);
    this.Workflow = new Workflow.API(this.common);
    this.WorkflowTest = new WorkflowTest.API(this.common);
  }
}
